import { useEffect } from "react";
import { useAppDispatch } from "@/store/hooks";
import { setPageSubtitle } from "@/store/slices/globalSlice";

// Lets a page set the Topbar's subtitle (PostLogin renders it next to the
// route-derived title). Clears it on unmount so the next page doesn't
// inherit a stale one.
export const usePageSubtitle = (subtitle: string | null) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setPageSubtitle(subtitle));

    return () => {
      dispatch(setPageSubtitle(null));
    };
  }, [dispatch, subtitle]);
};
